var map = {
	"./services-1.png": "ELKx",
	"./services-2.png": "u2NX",
	"./services-3.png": "iTmF",
	"./services-4.png": "XGiR"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "2y/F";


//////////////////
// WEBPACK FOOTER
// ./src/views/rescuelist/img/list ^\.\/services\-.*\.png$
// module id = 2y/F
// module chunks = 1